export const listProducts = `
   query listProducts($filter: ProductsFilterInput, $limit: Int, $nextToken: String) {
       listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              productTitle
              shortDescription
              productId
              productArn
              productCode
              status
              sku
              productLogoS3Url
              productVideoUrl
              highlightOne
              highlightTwo
              highlightThree
              productCategories
              keywordsForSearchResults
              meteringServiceSnsTopicArn
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProduct = `
   query getProduct($id:ID!) {
       getProduct(id:$id) {
        id
        productTitle
        shortDescription
        longDescription
        productId
        productArn
        productCode
        status
        sku
        productLogoS3Url
        productVideoUrl
        highlightOne
        highlightTwo
        highlightThree
        productCategories
        keywordsForSearchResults
        meteringServiceSnsTopicArn
        created
        updated
       }
}`;
